import React from 'react'
import { Box } from '@machobear/design-system'
import emptyAutoReplyMessage from '../images/empty-auto-reply-message.svg'

type Props = {
  location?: string
  alt?: string
  children?: any
}

const EmptyImage: React.FC<Props> = ({
  location = emptyAutoReplyMessage,
  alt = 'No Auto-Reply Messages',
  children
}) => {
  return (
    <Box component="img" src={location} alt={alt}>
      {children}
    </Box>
  )
}

export default EmptyImage
